import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";

export default function FormCompetence(props){
    return(
        <div style={{textAlign : 'start', background:'#f1f4fa', marginTop:5, border:'1px solid rgba(0, 0, 0, 0.1)', borderRadius:'20px', padding:'10px'}}>
            <p style={{textAlign:'start'}} className='p titre-steep'>Quelles compétences souhaiteriez-vous mettre en avant ?</p>

            {props.competences.map((competence, index) => (
            <div className="row" key={index} >
                {index > 0 ?
                        <div className="col-12" style={{marginTop:'10px'}}>
                            <p href="#" style={{fontWeight:'700' ,color:'red', textAlign:'end'}}  onClick={() => props.onSupprimerCompetence(index)}>
                                X 
                            </p>
                            
                        </div>
                        : null
                    }
                <div className="col-6">
                    <span style={{fontWeight: "900"}}>Compétences</span>
                    <input type="text" value={competence.skillNom} onChange={(e) => props.onChangeCompetence(index, 'skillNom', e.target.value)} className="form-control" />
                    {competence.skillNom === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgErrCmpetence}</p> : null}
                </div>
                <div className="col-6">
                    <span style={{fontWeight: "900"}}>Niveau</span>
                    <Form.Select className="form-control" value={competence.niveauSkill} onChange={(e) => props.onChangeCompetence(index, 'niveauSkill', e.target.value)} >
                        <option   > </option>
                        <option value="90">Excellent</option>
                        <option value="75">Bien</option>
                        <option value="50">Moyen</option>
                        <option value="15">Débutant</option>
                    </Form.Select>
                    {competence.niveauSkill === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgErrCmpetence}</p> : null}
                </div>
            </div>
            ))}

            <div style={{marginTop:'10px'}}>
                <p onClick={props.handleAjouterCompetence} style={{fontWeight:'700', fontSize:'15px', color:'red', textAlign:'start'}}>
                    <FontAwesomeIcon icon={faPlus} />  Ajouter une autre compétence                        

                </p>                             
            </div>

        </div>
    )
}